module.exports = __webpack_public_path__ + "img/home.bfa637af.jpg";